import React from 'react';

export function TetherIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.4721 6.60219L12.8721 3.38885C12.5588 2.75552 11.7254 2.24219 11.0188 2.24219H4.97876C4.2721 2.24219 3.43877 2.75552 3.12543 3.38885L1.52543 6.60219C1.13876 7.37552 1.35209 8.47552 1.98543 9.05552L6.60543 13.2489C7.3721 13.9422 8.61877 13.9422 9.38543 13.2489L14.0054 9.05552C14.6454 8.47552 14.8588 7.36885 14.4721 6.60219ZM10.6654 6.16885H8.49876V9.66885C8.49876 9.94219 8.2721 10.1689 7.99876 10.1689C7.72543 10.1689 7.49876 9.94219 7.49876 9.66885V6.16885H5.3321C5.05876 6.16885 4.8321 5.94219 4.8321 5.66885C4.8321 5.39552 5.05876 5.16885 5.3321 5.16885H10.6654C10.9388 5.16885 11.1654 5.39552 11.1654 5.66885C11.1654 5.94219 10.9388 6.16885 10.6654 6.16885Z"
        fill="currentColor"
      />
    </svg>
  );
}
